<ix-modal-header
  [requiredRoles]="requiredRoles"
  [title]="'Edit Certificate Authority' | translate"
  [loading]="isLoading"
></ix-modal-header>
<mat-card>
  <mat-card-content>
    <form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
      <ix-fieldset>
        <div class="columns">
          <ix-input
            class="column"
            formControlName="name"
            [label]="'Identifier' | translate"
            [required]="true"
            [tooltip]="helptext.edit.name.tooltip | translate"
          ></ix-input>
          <div class="column"></div>
        </div>
      </ix-fieldset>

      <ix-fieldset *ngIf="certificateAuthority" [title]="'Subject' | translate">
        <ix-certificate-details
          [certificate]="certificateAuthority"
        ></ix-certificate-details>

        <div class="view-actions">
          <button mat-button type="button" ixTest="view-certificate" (click)="onViewCertificatePressed()">
            {{ 'View/Download Certificate' | translate }}
          </button>

          <button mat-button type="button" ixTest="view-key" (click)="onViewKeyPressed()">
            {{ 'View/Download Key' | translate }}
          </button>
        </div>
        <div class="form-actions">
          <button
            *ixRequiresRoles="requiredRoles"
            mat-button
            type="submit"
            color="primary"
            ixTest="save"
            [disabled]="!form.valid || isLoading"
          >
            {{ 'Save' | translate }}
          </button>
        </div>
      </ix-fieldset>
    </form>
  </mat-card-content>
</mat-card>
